module.exports = __webpack_public_path__ + "img/highSpeedRail-4.9146f3af.jpg";